/** @jsxImportSource @emotion/react */

import React from 'react';
import { animated, useSpring } from 'react-spring';
import { AnimatedDelightProps } from './IAnimatedDelightProps';

export const AnimatedConfettiRight = ({ endScale = 1, startScale = 0 }: AnimatedDelightProps) => {
  const style1 = useSpring({
    to: {
      transform: `rotate(0deg) scale3d(${endScale}, ${endScale}, ${endScale})`
    },
    from: {
      transform: `rotate(250deg) scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    delay: 600,
    config: {
      tension: 400,
      friction: 20
    }
  });

  const style2 = useSpring({
    to: {
      transform: `rotate(0deg) scale3d(${endScale}, ${endScale}, ${endScale})`
    },
    from: {
      transform: `rotate(-90deg) scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    delay: 700,
    config: {
      tension: 400,
      friction: 20
    }
  });

  const style3 = useSpring({
    to: {
      transform: `rotate(0deg) scale3d(${endScale}, ${endScale}, ${endScale})`
    },
    from: {
      transform: `rotate(300deg) scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    delay: 800,
    config: {
      tension: 400,
      friction: 20
    }
  });

  const style4 = useSpring({
    to: {
      transform: `scale3d(${endScale}, ${endScale}, ${endScale})`
    },
    from: {
      transform: `scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    delay: 900,
    config: {
      tension: 400,
      friction: 20
    }
  });

  return (
    <div
      css={{
        height: '100%',
        right: '0',
        position: 'absolute',
        top: '300px',
        zIndex: -1
      }}
    >
      <svg
        css={{
          display: 'none',

          [`@media (min-width: 1050px)`]: {
            display: 'block',
            height: '295px',
            position: 'sticky',
            right: '0',
            top: '300px',
            width: '222px',
          }
        }}
        width="182"
        height="323"
        viewBox="0 0 182 323"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <animated.path
        css={{
            transformOrigin: '66px 288px'
        }}
        style={style4} d="M67.777 322.249L93.8428 307.77L63.6179 253.358L37.5522 267.837L67.777 322.249Z" fill="#D7E100" />
        <animated.path
        css={{
            transformOrigin: '121px 34px'
        }}
        style={style1} d="M96.3903 57.9227L124.138 68.8386L146.925 10.9159L119.177 4.04109e-05L96.3903 57.9227Z" fill="#D7E100" />
        <animated.path
        css={{
            transformOrigin: '158px 203px'
        }}
        style={style3} d="M134.441 227.925L162.94 236.697L181.252 177.206L152.753 168.434L134.441 227.925Z" fill="#F46508" />
        <animated.path
        css={{
            transformOrigin: '28px 134px'
        }}
        style={style2} d="M31.8866 169.565L57.4932 154.29L25.6064 100.836L-0.000131871 116.111L31.8866 169.565Z" fill="#E43896" />
      </svg>
    </div>
  );
};
